export default "__VITE_ASSET__DvAwlJuI__"